export class PTWPermission {
  public PTW_Add: boolean = false;
  public PTW_Add_Unit: boolean = false;
  public PTW_Admin_Unit: boolean = false;
  public PTW_Admin: boolean = false;
  public PTW_View_Unit: boolean = false;
  public PTW_View: boolean = false;
  public PTW_Area_Authority: boolean = false;
  public PTW_Area_Authority_Unit: boolean = false;
  public PTW_Responsible_Supervisor: boolean = false;
  public PTW_Responsible_Supervisor_Unit: boolean = false;
  public PTW_Production_Supervisor: boolean = false;
  public PTW_Production_Supervisor_Unit: boolean = false;
  public PTW_Authorised_Gas_Tester: boolean = false;
  public PTW_Authorised_Gas_Tester_Unit: boolean = false;
}
